import API from "./api";
import * as routes from './_routes';

export function searchOwners(options = {}) {
    return API.get(routes.SEARCH_OWNERS, {params: options})
}
